// React
import { useEffect, useState } from "react";
// Style
import "../../styles/menu/PaymentStyle.scss";
// Recoil
import { useSetRecoilState } from "recoil";
import { isRobot, isTooltipView } from "../../atom/menu";

function BotPopup() {
  // Recoil State
  const setIsTooltip = useSetRecoilState(isTooltipView);
  const setRobotView = useSetRecoilState(isRobot);
  // useState
  const [completePopup, setCompletePopup] = useState<boolean>(false);

  // Function
  useEffect(() => {
    setTimeout(() => {
      setCompletePopup(true);
    }, 3000);
  }, []);

  return (
    <>
      {completePopup ? (
        <div
          className='menu-popup-bg'
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            justifyContent: "space-between",
            padding: 24,
          }}
        >
          <div
            className='TO-title-2'
            style={{ textAlign: "center", color: "#D8D8D8", paddingTop: 84 }}
          >
            메뉴를 내리신 후,
            <br />
            <span className='text-color-red'>돌아가기</span> 버튼을 꼭
            눌러주세요.
          </div>
          <img
            src={"/assets/images/menu/botreturn.gif"}
            alt='order complete bot'
            style={{ width: 1100, position: "absolute", bottom: 0 }}
          />
          <div
            className='basic-btn TO-button-1 pointer'
            style={{
              maxWidth: 348,
              alignSelf: "flex-end",
              zIndex: 9,
            }}
            onClick={() => {
              setRobotView(false);
              setIsTooltip(true);
            }}
          >
            돌아가기
          </div>
        </div>
      ) : (
        <div
          className='menu-popup-bg'
          style={{ backgroundColor: "rgba(0, 0, 0, 0.75)" }}
        >
          <div
            className='TO-title-1'
            style={{
              textAlign: "center",
              color: "#D8D8D8",
              paddingBottom: 370,
            }}
          >
            로봇이 출발했습니다.
            <br />
            주문하신 메뉴가 곧 도착합니다.
          </div>
          <img
            src={"/assets/images/menu/botstart.gif"}
            alt='order complete bot'
            style={{ width: 1100, position: "absolute", bottom: 0 }}
          />
        </div>
      )}
    </>
  );
}
export default BotPopup;
